import React from 'react';

export function CardBlocks(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" {...props}>
      <path
        fill="#232529"
        fillRule="evenodd"
        d="M4.975 1.453h4.048c.68 0 1.224 0 1.663.036.45.037.84.114 1.198.297a3.05 3.05 0 0 1 1.333 1.332c.182.358.26.747.296 1.198.036.44.036.983.036 1.663v2.048c0 .68 0 1.224-.036 1.663-.037.45-.114.84-.296 1.198a3.05 3.05 0 0 1-1.333 1.333c-.358.182-.747.26-1.198.296-.44.036-.983.036-1.663.036H4.975c-.68 0-1.223 0-1.663-.036-.45-.037-.84-.114-1.197-.296a3.05 3.05 0 0 1-1.333-1.333C.599 10.53.522 10.14.485 9.69.45 9.25.45 8.707.45 8.027V5.979c0-.68 0-1.223.036-1.663.037-.45.114-.84.297-1.198a3.05 3.05 0 0 1 1.333-1.332c.357-.183.747-.26 1.197-.297.44-.036.984-.036 1.663-.036M3.402 2.585c-.383.032-.611.09-.788.18a1.95 1.95 0 0 0-.852.853c-.09.177-.15.405-.18.788-.032.39-.033.888-.033 1.597v2c0 .71 0 1.208.032 1.597.032.383.09.611.18.788.188.367.486.666.853.853.177.09.405.149.788.18.39.032.888.032 1.597.032h4c.71 0 1.208 0 1.597-.032.383-.031.612-.09.788-.18a1.95 1.95 0 0 0 .853-.853c.09-.177.149-.405.18-.788.032-.389.032-.888.032-1.597v-2c0-.709 0-1.208-.032-1.597-.031-.383-.09-.611-.18-.788a1.95 1.95 0 0 0-.853-.852c-.176-.09-.405-.15-.788-.18-.389-.032-.888-.033-1.597-.033H5c-.709 0-1.208 0-1.597.032"
        clipRule="evenodd"
      ></path>
      <mask id="path-2-inside-1_14679_610544" fill="#fff">
        <rect width="5" height="1.1" x="3" y="4" rx="0.5"></rect>
      </mask>
      <rect
        width="5"
        height="1.1"
        x="3"
        y="4"
        stroke="#000"
        strokeWidth="1.1"
        mask="url(#path-2-inside-1_14679_610544)"
        rx="0.5"
      ></rect>
      <mask id="path-3-inside-2_14679_610544" fill="#fff">
        <rect width="2" height="1.1" x="3" y="6" rx="0.5"></rect>
      </mask>
      <rect
        width="2"
        height="1.1"
        x="3"
        y="6"
        stroke="#000"
        strokeWidth="1.1"
        mask="url(#path-3-inside-2_14679_610544)"
        rx="0.5"
      ></rect>
    </svg>
  );
}
